import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from '../../ui/dialog';
import type { MapRegion } from '../../../types/map';

interface MapDialogProps {
  region: MapRegion | null;
  onClose: () => void;
  allRegions: MapRegion[];
}

const normalizeText = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

const displayRegionTitle = (value: string) => {
  const mapping: Record<string, string> = {
    triangulo: 'Triângulo',
    'noroeste e alto do paranaiba': 'Noroeste e Alto Paranaíba',
    'noroeste e alto paranaiba': 'Noroeste e Alto Paranaíba',
    'centro-oeste e sudoeste': 'Centro-Oeste e Sudoeste',
    'rio doce e vale do aco': 'Rio Doce e Vale do Aço',
    'zona da mata e vertentes': 'Zona da Mata',
  };

  return mapping[normalizeText(value)] || value;
};

const MapDialog: React.FC<MapDialogProps> = ({ region, onClose, allRegions }) => {
  if (!region) return null;

  const normalizedRegionTitle = normalizeText(region['map-region-title']);
  const regionCities = allRegions.filter(
    (item) => normalizeText(item['map-region-title']) === normalizedRegionTitle
  );

  return (
    <Dialog open={!!region} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-primary">
            {displayRegionTitle(region['map-region-title'])}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">Entre em contato com o Sebrae da sua região:</p>
          <div className="text-xs text-muted-foreground mb-2">
            {regionCities.length} {regionCities.length === 1 ? 'cidade' : 'cidades'} encontrada{regionCities.length === 1 ? '' : 's'}
          </div>
          <div className="space-y-2">
            {regionCities.map((cityData, index) => (
              <div key={index} className="flex justify-between items-center p-2 bg-muted rounded-md">
                <span className="font-medium text-sm">{cityData['map-region-city-title']}:</span>
                <span className="text-sm font-mono">{cityData['map-region-phone-number']}</span>
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MapDialog;
